export default "__VITE_ASSET__e9682857__"